import styled from 'styled-components';
import builtIndoors from '../../images/quiz/built-indoors.svg';
import buyersRemorse from '../../images/quiz/buyers-remorse.svg';
import prefab from '../../images/quiz/prefab.svg';
import claytonGrey from '../../images/quiz/CLAYTON_GREY.svg';

const IndexPageStyles = styled.div`
    h3 {
   font-size: 22.46px;
   margin-top: 22.4px;
 }
  .topCon {
    height: 85vh;
    padding: 12px;
    min-height: 600px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    z-index: 1;

     display: flex;
     justify-content: center;
     align-items: center;
     flex-direction: column;
  }
  .darken{
    position:absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0,0,0, .2);
    z-index: 2;
  }
  .content-quiz{
    width: 100%;
    position: relative;
    margin-top: 50px;
    z-index: 4;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .content{
    width: 100%;
    position: relative;
    margin-top: 65px;

    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: row;
  }
  .header{
    color: white;
    text-shadow: 0 2px 4px rgba(0,0,0,0.5);
    font-size: 72px;
    line-height: 72px;
    font-weight: 800;
    padding: 0 6px;
    width: 450px;
    margin: 0;
    letter-spacing: -1px;
    position: relative;
    z-index: 3;
  }
  .header-quiz{
    text-align: center;
    width: 90%;
    font-size: 64px;

  }
  .button-quiz{
    background-image: linear-gradient(180DEG, #26C6DA 0%, #2098D4 100%);
    border: none;
    border-radius: 20px;
    color: white;
    cursor: pointer;
    display: block;
    font-family: "acumin-pro", sans-serif;
    font-size: 18px;
    height: 40px;
    letter-spacing: .05rem;
    margin: 18px auto 0 auto;
    outline: none;
    overflow: hidden;
    padding-left: 35px;
    padding-right: 35px;
    white-space: nowrap;
    z-index: 3;
  }
  .middleCon{
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    flex-direction: row;
    padding: 30px 30px;
    flex:1;
  }
  .middle-section{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }
  .middle-section .img{
    height: 100px;
    width: 100px;
    display: block;

    transition: all .3s ease-in-out;
  }
  
  .modal-contents.modal-content-sm{
    padding: 0;
  }
  .modal-contents{
    padding: 0;
    width: auto !important;
    background: transparent;
    text-align: left;
    overflow: hidden;
    
  }
  .built .img{
    background: url(${builtIndoors});
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  
    transition: all .3s ease-in-out;
  }
  .prefab .img{
    background: url(${prefab});
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .buy .img{
    background: url(${buyersRemorse});
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .middle-section-content{
    margin: 19.2px 0;
    font-size: 19.2px;
    text-align: center;
    width: 30vw;
    padding: 0 12px;
  }
  .middle-section-header{
    text-align: center;
    margin-bottom: 0;
  }
   .form-modal{
    background: #fff;
    padding: 30px;
  }
  .footer{
    height: 75px;
    background: rgba(245, 245, 245, 0.48);
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }
  .legal{
    font-size: 10px;
  }
  .legal-text, .privacy{
    font-size: 10px;
    color: #008ACB;
    }
    .href{
      color:  #008ACB;
    }
  .footLogo{
    width: 100px;
    height: 60px;
    background: url(${claytonGrey}) center center no-repeat;
    background-size: 100%;
  }
  @media (max-width: 55em) {
    .content {
      flex-direction: column;
      margin-top: 50px;
    }
    .header {
      font-size: 48px;
      line-height: 48px;
      width: 80%;
      margin-bottom: 32px;
      margin-top:  16px;
      text-align: center;
    }
    .topCon{
      height: auto;
    }
    .middle-section{
      margin-bottom: 60px;
    }
    .middle-section:last-child{
      margin-bottom: 0;
    }
    .middle-section .img{
      height: 150px;
      width: 150px;
    }
    .middleCon{
      height: auto;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      flex:auto;
    }
    .middle-section-content{
      width: 70%;
    }
    .middle-section-header{
      font-size: 24px;
    }
  }
  
  
  @media (max-width: 45em) {
    .footer{
      flex-direction: column;
      margin: 25px 0 0;
    }
    .legal{
      margin-bottom: 18px;
    }
  }
  @media (max-width: 24em) {
    .content {
      flex-direction: column;
    }
    .header {
      font-size: 32px;
      line-height: 32px;
      width: 80%;
      margin-bottom: 16px;
    }
    .topCon{
      height: auto;
    }
    .middle-section-content{
      width: 85%;
    }
  }
`;

export default IndexPageStyles;